const pad = (n) => String(n).padStart(2, "0");

export const rupiah = (n) => `Rp ${Number(n || 0).toLocaleString("id-ID")}`;

export const toISODate = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

export const parseISODate = (s) => {
  const [y, m, d] = s.split("-").map(Number);
  return new Date(y, m - 1, d);
};

export const addDays = (s, n) => {
  const d = parseISODate(s);
  d.setDate(d.getDate() + n);
  return toISODate(d);
};

export const eachDay = (start, end) => {
  const days = [];
  for (let d = start; d <= end; d = addDays(d, 1)) days.push(d);
  return days;
};

export const todayISO = () => toISODate(new Date());
export const startOfMonth = (d) => new Date(d.getFullYear(), d.getMonth(), 1);
export const shiftMonth = (d, n) => new Date(d.getFullYear(), d.getMonth() + n, 1);
export const monthLabel = (d) => d.toLocaleDateString("id-ID", { month: "long", year: "numeric" });

export const monthBounds = (month, extraDays = 0) => ({
  start: toISODate(startOfMonth(month)),
  end: toISODate(new Date(month.getFullYear(), month.getMonth() + 1, extraDays)),
});

export const formatDate = (s, opts = {}) =>
  s ? parseISODate(s).toLocaleDateString("id-ID", { day: "numeric", month: "long", year: "numeric", ...opts }) : "-";

export const formatShortDate = (s) => formatDate(s, { month: "short" });

export const formatRange = (a, b) =>
  !b || a === b ? formatDate(a) : `${formatDate(a, { month: "short", year: undefined })} – ${formatDate(b, { month: "short" })}`;

export const normalizePhone = (phone = "") => {
  const digits = phone.replace(/\D/g, "");
  if (digits.startsWith("0")) return `62${digits.slice(1)}`;
  if (digits.startsWith("8")) return `62${digits}`;
  return digits;
};

export const waLink = (phone, text = "") => `https://wa.me/${normalizePhone(phone)}?text=${encodeURIComponent(text)}`;

export const ORDER_STATUS = {
  menunggu: { label: "Menunggu Pembayaran", cls: "border-amber-400/30 bg-amber-400/10 text-amber-300" },
  dp: { label: "DP Diterima", cls: "border-sky-400/30 bg-sky-400/10 text-sky-300" },
  lunas: { label: "Lunas", cls: "border-emerald-400/30 bg-emerald-400/10 text-emerald-300" },
  selesai: { label: "Selesai", cls: "border-white/20 bg-white/5 text-neutral-300" },
  batal: { label: "Batal", cls: "border-rose-400/30 bg-rose-400/10 text-rose-300" },
};

export const STATUS_FLOW = ["menunggu", "dp", "lunas", "selesai"];

export const INCOME_CATEGORIES = ["Pembayaran Order", "Sewa Alat", "Lainnya"];
export const EXPENSE_CATEGORIES = [
  "Honor Guide",
  "Porter",
  "Transportasi",
  "Logistik / Makanan",
  "Simaksi / Izin",
  "Peralatan",
  "Operasional",
  "Lainnya",
];

export const brandParts = (name = "") => {
  const main = name.replace(/^private trip\s*/i, "");
  return { prefix: main !== name ? "Private Trip" : "", main: main || name };
};
